
import { Controller } from "stimulus"

export default class extends Controller {

  initialize() {
    document.addEventListener('turbolinks:before-cache', function() {
      document.getElementById('closeReadMoreModal')?.click();
    })
  }

  registerInterest(event) {
    event.preventDefault()
    const sessionType = event.currentTarget.dataset.sessionType
    // Track feature interest (previously used Intercom)
    console.log('Feature interest:', sessionType);
  }


}
